import { render, staticRenderFns } from "./FissionPrizeUpdatePane.vue?vue&type=template&id=681acc87&scoped=true"
import script from "./FissionPrizeUpdatePane.vue?vue&type=script&lang=js"
export * from "./FissionPrizeUpdatePane.vue?vue&type=script&lang=js"
import style0 from "./FissionPrizeUpdatePane.vue?vue&type=style&index=0&id=681acc87&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681acc87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681acc87')) {
      api.createRecord('681acc87', component.options)
    } else {
      api.reload('681acc87', component.options)
    }
    module.hot.accept("./FissionPrizeUpdatePane.vue?vue&type=template&id=681acc87&scoped=true", function () {
      api.rerender('681acc87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/fission/components/FissionPrizeUpdatePane.vue"
export default component.exports